import { Injectable } from '@angular/core';
import { MenuModel } from '@app/shared/models/menu-model';
import { Prices } from '@shared/models/prices';

interface OfferBenefits {
    inc_ids: number[];
    exc_ids: number[];
    pass_id: number[];
    brand_benefits: Record<number, BrandOffer>;
    code_type: string;
}

interface BrandOffer {
    benefits: {
        type: 'percentage_discount' | 'amount_discount';
        value: number;
    };
}

@Injectable({
    providedIn: 'root'
})
export class SubscriptionPriceService {
    private offerBenefits: OfferBenefits;
    private menu: MenuModel;

    constructor(response: any, menu: MenuModel) {
        this.offerBenefits = response.offer_benefits;
        this.menu = menu;
    }

    applyPassPrices(): void {
        const { code_type } = this.offerBenefits;
        if (code_type.toLowerCase() !== 'subscription') return;

        const eligibleSizeIds = this.getEligibleProductSizeIds();
        const brandOffer = this.getBrandOffer();

        for (const product of Object.values(this.menu.products)) {
            for (const size of product.product_sizes) {
                if (eligibleSizeIds.includes(size.id)) {
                    size.prices = this.getPrices(size.prices, brandOffer);
                }
            }
        }
    }

    getEligibleProductSizeIds(): number[] {
        const { inc_ids, exc_ids } = this.offerBenefits;
        let productSizeIds = Object.keys(this.menu.product_sizes).map(Number);

        if (exc_ids.length) {
            productSizeIds = productSizeIds.filter(id => !exc_ids.includes(id));
        }

        if (inc_ids.length) {
            productSizeIds = productSizeIds.filter(id => inc_ids.includes(id));
        }

        return productSizeIds;
    }

    getBrandOffer(): BrandOffer {
        const brandId = this.menu.brand_id;
        return this.offerBenefits.brand_benefits[brandId];
    }

    getPrices(prices: Prices, brandOffer: BrandOffer): Prices {
        const { type, value } = brandOffer.benefits;
        const { pass_id } = this.offerBenefits;
        let price = prices.discounted_price;

        if (type === 'percentage_discount') {
            price = Math.round(prices.discounted_price * (1 - value / 100));
        } else if (type === 'amount_discount') {
            price = Math.max(0, prices.discounted_price - value);
        }

        const subscription_prices = pass_id.map(id => ({
            pass_id: id,
            price
        }));

        return {
            ...prices,
            subscription_prices
        };
    }
}
